import { AuthService } from './shared/services/auth.service';
import { CommonDataSharingService } from './shared/services/common-data-sharing.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private _commonData: CommonDataSharingService, private _auth: AuthService) {
    if (this._auth.isAuthenticated) {
      this._commonData._getBusinessesList();
    }

  }

}
